import * as React from 'react';
import ProductOptionsStrings from './ProductOptionsStrings';
import { Icon } from '@doordash/design-language';
export var ddfwPlatformRowData = [
    {
        benefitName: ProductOptionsStrings.benefitTeamSize(),
        smallTeam: function () { return ProductOptionsStrings.benefitTeamSizeSmallTeamLimit(); },
        corporate: function () { return ProductOptionsStrings.benefitTeamSizeCorporateLimit(); },
    },
    {
        benefitName: ProductOptionsStrings.benefitNumberOfMealBudgets(),
        smallTeam: function () {
            return ProductOptionsStrings.benefitNumberOfMealBudgetsSmallTeamLimit();
        },
        corporate: function () {
            return ProductOptionsStrings.benefitNumberOfMealBudgetsCorporateLimit();
        },
    },
    {
        benefitName: ProductOptionsStrings.benefitBudgetRestriction(),
        smallTeam: function () {
            return ProductOptionsStrings.benefitBudgetRestrictionSmallTeamLimit();
        },
        corporate: function () {
            return ProductOptionsStrings.benefitBudgetRestrictionCorporateLimit();
        },
    },
    {
        benefitName: ProductOptionsStrings.benefitPaymentMethods(),
        smallTeam: function () {
            return ProductOptionsStrings.benefitPaymentMethodsSmallTeamLimit();
        },
        corporate: function () {
            return ProductOptionsStrings.benefitPaymentMethodsCorporateLimit();
        },
    },
    {
        benefitName: ProductOptionsStrings.benefitEmployeeCanChoose(),
        smallTeam: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
        corporate: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
    },
    {
        benefitName: ProductOptionsStrings.benefitSpendingRules(),
        smallTeam: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
        corporate: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
    },
    {
        benefitName: ProductOptionsStrings.benefitOnsiteAndRemoteEmployees(),
        smallTeam: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
        corporate: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
    },
    {
        benefitName: ProductOptionsStrings.benefitEnterpriseIntegrations(),
        smallTeam: function () { return null; },
        corporate: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
    },
];
export var accountRowData = [
    {
        benefitName: ProductOptionsStrings.benefitAccountManager(),
        smallTeam: function () { return null; },
        corporate: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
    },
    {
        benefitName: ProductOptionsStrings.benefitCustomerSupport(),
        smallTeam: function () { return null; },
        corporate: function () { return (React.createElement(Icon, { type: Icon.Types.Check, color: Icon.Colors.SystemGreen60 })); },
    },
    {
        benefitName: ProductOptionsStrings.benefitAvailability(),
        smallTeam: function () { return ProductOptionsStrings.benefitAvailabilitySmallTeamLimit(); },
        corporate: function () { return ProductOptionsStrings.benefitAvailabilityCorporateLimit(); },
    },
];
export var dasspassForWorkBenefitList = [
    ProductOptionsStrings.dashpassForWorkBenefitOne(),
    ProductOptionsStrings.dashpassForWorkBenefitTwo(),
    ProductOptionsStrings.dashpassForWorkBenefitThree(),
    ProductOptionsStrings.dashpassForWorkBenefitFour(),
];
export var dasspassForWorkTileContent = {
    title: ProductOptionsStrings.dashpassForWorkTileTitle(),
    subtitle: ProductOptionsStrings.dashpassForWorkTileSubtitle(),
    benefitList: dasspassForWorkBenefitList,
    buttonText: ProductOptionsStrings.contactSalesButton(),
};
export var giftCardsBenefitList = [
    ProductOptionsStrings.giftCardsBenefitOne(),
    ProductOptionsStrings.gitftCardsBenefitTwo(),
];
export var giftCardsTileContent = {
    title: ProductOptionsStrings.giftCardsTileTitle(),
    subtitle: ProductOptionsStrings.giftCardsTileSubtitle(),
    benefitList: giftCardsBenefitList,
    buttonText: ProductOptionsStrings.giftCardButton(),
};
export var smallTeamIncludedBenefits = [
    ProductOptionsStrings.benefitEmployeeCanChoose(),
    ProductOptionsStrings.benefitSpendingRules(),
    ProductOptionsStrings.benefitOnsiteAndRemoteEmployees(),
];
export var smallTeamExcludedBenefits = [
    ProductOptionsStrings.benefitEnterpriseIntegrations(),
    ProductOptionsStrings.benefitAccountManager(),
    ProductOptionsStrings.benefitCustomerSupport(),
];
export var smallTeamTileContent = {
    title: ProductOptionsStrings.smallTeam(),
    planDetails: [
        {
            benefitName: ProductOptionsStrings.benefitTeamSize(),
            detail: ProductOptionsStrings.benefitTeamSizeSmallTeamLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitNumberOfMealBudgets(),
            detail: ProductOptionsStrings.benefitNumberOfMealBudgetsSmallTeamLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitBudgetRestriction(),
            detail: ProductOptionsStrings.benefitBudgetRestrictionSmallTeamLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitPaymentMethods(),
            detail: ProductOptionsStrings.benefitPaymentMethodsSmallTeamLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitAvailability(),
            detail: ProductOptionsStrings.benefitAvailabilitySmallTeamLimit(),
        },
    ],
    lists: [
        {
            title: ProductOptionsStrings.benefitWhatIsIncluded(),
            benefits: smallTeamIncludedBenefits,
            iconType: Icon.Types.Check,
        },
        {
            title: ProductOptionsStrings.benefitWhatIsExcluded(),
            benefits: smallTeamExcludedBenefits,
            iconType: Icon.Types.Close,
        },
    ],
    buttonText: ProductOptionsStrings.signUpNowButton(),
};
export var corporateOrderingIncludedBenefits = [
    ProductOptionsStrings.benefitEmployeeCanChoose(),
    ProductOptionsStrings.benefitSpendingRules(),
    ProductOptionsStrings.benefitOnsiteAndRemoteEmployees(),
    ProductOptionsStrings.benefitEnterpriseIntegrations(),
    ProductOptionsStrings.benefitAccountManager(),
    ProductOptionsStrings.benefitCustomerSupport(),
];
export var corporateOrderingTileContent = {
    title: ProductOptionsStrings.corporateOrdering(),
    planDetails: [
        {
            benefitName: ProductOptionsStrings.benefitTeamSize(),
            detail: ProductOptionsStrings.benefitTeamSizeCorporateLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitNumberOfMealBudgets(),
            detail: ProductOptionsStrings.benefitNumberOfMealBudgetsCorporateLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitBudgetRestriction(),
            detail: ProductOptionsStrings.benefitBudgetRestrictionCorporateLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitPaymentMethods(),
            detail: ProductOptionsStrings.benefitPaymentMethodsCorporateLimit(),
        },
        {
            benefitName: ProductOptionsStrings.benefitAvailability(),
            detail: ProductOptionsStrings.benefitAvailabilityCorporateLimit(),
        },
    ],
    lists: [
        {
            title: ProductOptionsStrings.benefitWhatIsIncluded(),
            benefits: corporateOrderingIncludedBenefits,
            iconType: Icon.Types.Check,
        },
    ],
    buttonText: ProductOptionsStrings.contactSalesButton(),
};
export var PageSections;
(function (PageSections) {
    PageSections["EmployeeMeals"] = "EmployeeMeals";
    PageSections["EmployeePerks"] = "EMployeePerks";
})(PageSections || (PageSections = {}));
